// extracted by mini-css-extract-plugin
export default {"image-preview":"ImagePreview_image-preview__8NpqG","svg":"ImagePreview_svg__AKYVC","image":"ImagePreview_image__qiQ1e","backdrop":"ImagePreview_backdrop__EcMn-"};